import angular from 'angular';

export default /* .service('commissionModalService', CommissionModalService) */ angular.module(
  'businessEmailMailTemplates.services',
  [],
).name;
